<template>
    <div class="content">
        <div class="header">{{ data.industryName }}</div>
        <div class="close" @click="$emit('cancel')"><CloseCircleOutlined /></div>
        <div class="text">
            <p><span>主体名称：</span>{{ data.industryName }}</p>
            <p><span>所在镇街：</span>{{ data.towns }}</p>
            <p><span>联系地址：</span>{{ data.industryAddress }}</p>
            <p><span>联系人：</span>{{ data.linkman }}</p>
            <p><span>联系电话：</span>{{ data.phone }}</p>
            <p><span>经纬度：</span>{{ data.coordinate ? parseFloat(data.coordinate.split(',')[0]).toFixed(5) + ',' + parseFloat(data.coordinate.split(',')[1]).toFixed(5) : '' }}</p>
        </div>
        <div class="profile">
            <div class="profile-text">
                <h2>基地简介</h2>
                <p>{{ data.introduction }}</p>
            </div>
            <div class="profile-img">
                <a-carousel autoplay>
                    <div class="div-img" v-for="(item, i) in imgList" :key="i"><img :src="item" alt=""></div>
<!--                    <div class="div-img"><img src="../../../assets/img/page_banner_1.png" alt=""></div>-->
                </a-carousel>
            </div>
        </div>
        <div class="buttons">
            <a-space>
                <div class="b-button" @click="videoClick">基地宣传片</div>
                <div class="b-button" v-if="cameraList.length > 0" @click="cameraClick">视频监控</div>
                <a-tooltip v-else placement="topLeft" title="暂无视频" arrow-point-at-center>
                    <div class="b-button">视频监控</div>
                </a-tooltip>
            </a-space>
        </div>
        <a-modal v-model:visible="videoVisible" title="基地宣传片" :width="850" :footer="false" :destroyOnClose="true">
            <video :src="videoUrl" controls="controls" width="800" height="600" autoplay="autoplay"></video>
        </a-modal>
        <windowPlayer
            :video-visible="cameraVisible"
            :title="data.industryName"
            @cancel="() => {cameraVisible = false}"
            ref="windowPlayerRef"
        ></windowPlayer>
    </div>
</template>

<script>
import { CloseCircleOutlined } from '@ant-design/icons-vue'
import { ref } from 'vue'
import windowPlayer from "../../../components/video/windowPlayer"
export default {
    name: "infoBox",
    setup() {
        const data = ref({})
        const imgList = ref([])
        const videoUrl = ref('')
        const videoVisible = ref(false)
        const cameraVisible = ref(false)
        const cameraList = ref([])
        return {
            data,
            imgList,
            videoVisible,
            cameraVisible,
            cameraList,
            videoUrl
        }
    },
    methods: {
        setData(data) {
            this.cameraList = data.camera ? data.camera.split(',') : []
            if (data.imgs) {
                this.imgList = data.imgs.split(',')
            }
            this.data = data
        },
        videoClick() {
            this.videoVisible = true
            this.$nextTick(() => {
                this.videoUrl = this.data.video
            })
        },
        cameraClick() {
            this.cameraVisible = true
            this.$nextTick(() => {
                this.$refs.windowPlayerRef.init(this.cameraList)
            })
        },
        fuckCancel() {
            console.log(123123213123)
        }
    },
    components: {
        CloseCircleOutlined,
        windowPlayer
    }
}
</script>

<style scoped lang="stylus">
    .content {
        width 1130px
        height 650px
        position fixed
        top 250px
        left calc(50% - 565px)
        z-index 1
        background-image url("../../../assets/img/infoBox_bg.png")
        background-size 100% 100%
        background-repeat no-repeat
        .header {
            width 100%
            height 106px
            line-height 106px
            padding-left 130px
            font-size 35px
            color #FFF
            font-family 'PangMenZhengDao'
        }
        .close {
            position absolute
            top 30px
            right 70px
            color #fff
            font-size 40px
            cursor pointer
        }
        .text {
            width 100%
            height 155px
            display flex
            flex-wrap wrap
            justify-content space-between
            padding 20px 95px 20px 95px
            font-size 24px
            color #FFF
        }
        .text p {
            width 50%
            overflow hidden
            text-overflow ellipsis
            white-space nowrap
        }
        .text p span:first-child {
            color #3EF5FC
            display inline-block
            min-width 115px
        }
        .profile {
            width 100%
            height 300px
            padding 0 90px
            display flex
            flex-wrap wrap
            justify-content space-between
            .profile-text {
                width 49.5%
                height 100%
                background rgba(0, 214, 225, 0.5)
                border 1px solid #00D6E1
                border-radius 12px
                padding 5px 20px
                overflow-y auto
            }
            .profile-text h2 {
                color #3EF5FC
            }
            .profile-text p {
                color #FFF
                font-size 15px
                width 100%
                text-indent 30px
            }
            .profile-img {
                width 49.5%
                height 100%
                background rgba(0, 214, 225, 0.5)
                border 1px solid #00D6E1
                border-radius 12px
                overflow hidden
                /deep/ .ant-carousel {
                    width 100%
                    text-align center
                    height 298px
                    line-height 298px
                    background #364d79
                    overflow hidden
                    .div-img {
                        width 100%
                        height 298px
                    }
                    .div-img img {
                        width 100%
                        height 298px
                        object-fit cover
                    }
                }
            }
        }
        .buttons {
            width 100%
            padding 10px 0 0 110px
            .b-button{
                font-size 21px
                color #FFF
                display inline-block
                font-family 'PangMenZhengDao'
                text-align center
                padding 0 10px
                background rgba(0, 214, 225, 0.75)
                border 1px solid #00D6E1
                border-radius 6px
                cursor pointer
            }
        }
    }
</style>